// extracted by mini-css-extract-plugin
module.exports = {"editIconButton":"CompletionReasonEditor_editIconButton__2p7px","fields":"CompletionReasonEditor_fields__2AZtE"};